export const FILES_TAGS = {
  FILES_TAG: "Files",
  FILES_SEARCH_TAG: "FilesSearch",
  FILES_FAVORITES_TAG: "FilesFavorites",
  DIRECTORY_UPLOAD_OPERATION_TAG: "DirectoryUploadOperation",
};
